<!--
     <InlineBoxIndicatorTracking
       :props="{qunits:QUnitCollection, actions:[]}"
       @update="update_qunit(data)"
     />
-->

<template>
  <div>
    <TableTable
      ref="table"
      v-if="!is_mobile && qunits && qunits.length"
      :qunits="local_qunits"
      @update="update_filters"
      @update-qunit="update_qunit"
      :key="qunits.instance_id"
      @navigate_to="goto_qunit"
      @click="clicked_qunit"
      actions
      selectable
      :action_list="current_actions"
      navigate
      :header_slots="['readable_type']"
    >
      <template v-slot:readable_type="{header}">
        <div class="qmkey-explorer-table-header">
          <span>
            {{ header.text }}
          </span>
          <GenericSelector v-if="filtered_selector_list.length > 1"
                           class="qmkey-explorer-table-header-filter"
                           :items="filtered_selector_list"
                           :current_selected="local_filters.get_filter_value('business_process_include')"
                           multiple
                           checkbox
                           @update="update_selected"
          ></GenericSelector>
        </div>
      </template>
    </TableTable>

    <ExplorerCardList
      v-else-if="is_mobile && qunits && qunits.length"
      ref="card"
      :qunits="local_qunits"
      @update="update_filters"
      @update-qunit="update_qunit"
      :key="'card' + qunits.instance_id"
      @navigate_to="goto_qunit"
      @click="clicked_qunit"
      actions
      navigate
      :action_list="current_actions"
    >
      <template v-slot:header_right_panel>
        <div>
          <v-btn
            @click.stop="header_filter_dialog = true"
            icon
            small
          >
            <v-icon small>mdi-tune-vertical</v-icon>
          </v-btn>
          <v-dialog 
            v-model="header_filter_dialog" 
            width="fit-content"
          >
            <div class="white">
              <div class="d-flex pa-2 pl-8 pr-8 ma-auto w-auto">
                <span>{{ $vuetify.lang.translator('type') }}</span> <!-- TODO: Here is the header name, harcoded to type as normal table -->
                <GenericSelector
                  v-if="filtered_selector_list.length > 1"
                  class="qmkey-explorer-table-header-filter"
                  :items="filtered_selector_list"
                  :current_selected="local_filters.get_filter_value('business_process_include')"
                  multiple
                  checkbox
                  @update="update_selected"
                ></GenericSelector>
              </div>
            </div>
          </v-dialog>
        </div>
      </template>
    </ExplorerCardList>

    <div v-else class="hcenter">
      <div class="pa-3">
        {{ $vuetify.lang.translator('explorer.no_data') }}
      </div>
    </div>

    <!-- Related inline do not expand items -->
    <!--<MobileQUnitView
         ref="qunit_view"
         :key="'qunit_view' + qunits.instance_id"
         :unit="qunit_clicked"
         :columns="qunits.columns"
         @navigate_to="goto_qunit"
         actions
         navigate
         :logo="is_mobile"
         :card="is_mobile"
         :tabs="false"
         inline
         />-->
  </div>
</template>


<style lang="scss">
 @import "@/sass/explorer.scss";
</style>


<script>
 import GenericSelector from '@/components/explorer/GenericSelector'
 import { QFilters } from '@/qunit/filters';

 export default {
   name: 'InlineBoxIndicatorTracking',

   components: {
     TableTable: () => import('@/components/explorer/table/TableTable'), // https://stackoverflow.com/questions/49154490/did-you-register-the-component-correctly-for-recursive-components-make-sure-to
     GenericSelector,
     ExplorerCardList: () => import('@/components/explorer/ExplorerCardList'),
     MobileQUnitView: () => import('@/components/explorer/MobileQUnitView'),
   },

   props: {
     qunits: {required: true},
     pk: {},
     props: {required: true},
     is_mobile: {type: Boolean, default: false},
   },

   data: () => ({
     local_filters: new QFilters(),
     qunit_clicked: null,
     header_filter_dialog: false,
   }),

   computed: {
     local_qunits() {
       return this.qunits.filter(this.local_filters);
     },
     
     local_selector_list() {
       let res = [];

       if (this.props.filter_includes) {
         // TODO: This might be wrong, revise it
         res = this.props.filter_includes.map(bp => ({
           id: bp,
           name: (this.qunits.units
                      .filter(u => u.bp_reference === bp)
                      .readable_type.value),
         }));

       } else {
         res = this.qunits.units.map(unit => ({
           id: unit.bp_reference,
           name: unit.readable_type.value
         }));
       }

       return res;
     },

     filtered_selector_list() {
       const duplicates_removed = [... new Set(this.local_selector_list.map((item) => item.id))] // Array with id
         .map(id => this.local_selector_list.find(it => it.id === id)) //Recover first object with id
       return duplicates_removed.sort((a, b) => {
         const nameA = a.name.toUpperCase(); // ignore upper and lowercase
         const nameB = b.name.toUpperCase(); // ignore upper and lowercase
         if (nameA < nameB) {
           return -1;
         }
         if (nameA > nameB) {
           return 1;
         }
         return 0;
       });
     },

     current_actions() {
       let actions = JSON.parse(JSON.stringify(this.props)).actions
       actions.splice(1, 0, 'ActionViewQUnit');
       return actions
     },
   },

   mounted() {
     this.qunit_selected();
   },

   updated() {
     //Mobile views not updating the selected qunit after transition
     this.qunit_selected();
   },

   methods: {
     update_filters(ef) {
       this.local_filters = this.local_filters.merge(ef);
     },

     update_qunit(data) {
       this.$emit('update', data);
       this.$nextTick(() => {
         this.qunit_selected();
       });
     },

     goto_qunit(qunit) {
       this.$router.push({
         path: 'explorer',
         query: {
           business_process: qunit.get_filter_value('business_process'),
           pk: qunit.uid
         },
       });
     },

     clicked_qunit(qunit) {
       /* Related inline do not expand items */
       /*if (this.is_mobile && qunit) {
          this.qunit_clicked = qunit;
          this.$refs.qunit_view.open();
          }*/
     },

     update_selected(selected) {
       this.update_filters(new QFilters({business_process_include: selected}));
     },

     qunit_selected() {
       if (this.pk) {
         const view_ref = this.is_mobile ? 'card' : 'table';
         let view_state = this.$refs[view_ref].export_state();
         view_state.selected = [this.pk]
         this.$refs[view_ref].import_state(view_state);
       }
     },
   },
 }
</script>
